import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import logo from "../logo-removebg-preview.png"
import { useAuth0 } from "@auth0/auth0-react";
import Button from '@material-ui/core/Button';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import { FormatColorReset } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  left: {
    marginLeft: 20,

  },
  left1: {
    marginLeft: 20,
    height: 45    
  },
  top: {
    marginTop: 5
  },
  box: {
    display: 'flex',
    flexDirection: 'row'
  },
  logoTitle: {
    marginTop: 24,
    marginLeft: -35,
    fontSize: 30,
    fontWeight: 800

  }
}));

function Header() {
  const classes = useStyles();

 const { loginWithRedirect, user, isAuthenticated, isLoading, logout } = useAuth0();
 console.log(user, isAuthenticated)
  const [top, setTop] = useState(true);

  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true)
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]);  

  let navigate;
  let nav = (
    <nav className="flex flex-grow">
            <ul className="flex flex-grow justify-end flex-wrap items-center">
            
            {/* <Button className = {classes.left} variant = "contained" disableElevation onClick={() => loginWithRedirect()}>
            Sign In
              </Button> */}
            <a className="btn text-white bg-blue-600 hover:bg-blue-700 shadow">
                      <button font-size = '16' onClick={() =>
        loginWithRedirect({
          screen_hint: "signup",
        })
      }>
                      SignUp
                      </button>
                      </a>
            </ul>

          </nav>
  )
  let navLogged = (
    <nav className="flex flex-grow">
            <ul className="flex flex-grow justify-end flex-wrap items-center">
            <Button onClick={() => logout()} variant="contained">Logout</Button>
            </ul>

          </nav>
  )
  
  if(isAuthenticated === true) {
    navigate = navLogged
  }else {
    navigate = nav
  }
  return (
    <header className={`fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ${!top && 'bg-white blur shadow-lg'}`}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Site branding */}
          <div className="flex-shrink-0 mr-4">
            {/* Logo */}
            <Box className = {classes.box}>
            <Link to="/" className="block" aria-label="Cruip">
              {/* <svg className="w-8 h-8" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <radialGradient cx="21.152%" cy="86.063%" fx="21.152%" fy="86.063%" r="79.941%" id="header-logo">
                    <stop stopColor="#4FD1C5" offset="0%" />
                    <stop stopColor="#81E6D9" offset="25.871%" />
                    <stop stopColor="#338CF5" offset="100%" />
                  </radialGradient>
                </defs>
                <rect width="32" height="32" rx="16" fill="url(#header-logo)" fillRule="nonzero" />
              </svg> */}
              <img className = {classes.top}  width="125" height="125"  src={logo} />
              
            </Link>
            <Link to="/" className="block" aria-label="uninity">
            <Typography className = {classes.logoTitle}>
              UNINITY
              </Typography>
              </Link>
            </Box>
          </div>

          {/* Site navigation */}
          {navigate}

        </div>
      </div>
    </header>
  );
}

export default Header;
